import { useEmpCheckinsModal } from "./use-checkin-modal";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { DataTable } from "./checkin-table/data-table";
import { columns } from "./checkin-table/columns";

export const EmployeeCheckinsModal = ({
  data = [],
}: {
  data: {
    id: string;
    mode: string;
    time: string;
    createdAtIST: string | Date;
    workDoneToday: string;
    attachments:
      | {
          doc: string;
          url: string;
        }[]
      | undefined;
  }[];
}) => {
  const { open, onOpenChange } = useEmpCheckinsModal();

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-5xl overflow-y-scroll max-h-[580px]">
          <DialogHeader>
            <DialogTitle>Employee Checkins</DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <DataTable data={data} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
